let controller = {
    start: () => {},
    done: () => {},
};

export function setTopLoadingController(c) {
    if (!c || typeof c !== 'object') return;
    controller = {
        start: typeof c.start === 'function' ? c.start : () => {},
        done: typeof c.done === 'function' ? c.done : () => {},
    };
}

export function startLoading() {
    try {
        controller.start();
    } catch (e) {
        console.error(e);
        // ignore
    }
}

export function stopLoading() {
    try {
        controller.done();
    } catch (e) {
        console.error(e);
        // ignore
    }
}
